import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Typography,
  StepConnector,
  Paper,
  Card,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import { PhoneOutlined } from "@mui/icons-material";
import DynamicTable from "../../components/DynamicTable";
import DashboardTable from "../../components/NewTable/DashboardTable";
import truck from "../../assets/images/svg/truck.svg";
import reload from "../../assets/images/svg/reload.svg";
import add from "../../assets/images/svg/add.svg";
import info from "../../assets/images/svg/info.svg";
import driver from "../../assets/images/svg/driver.svg";
import reviewRed from "../../assets/images/svg/reviewRed.svg";
import reject from "../../assets/images/svg/reject.svg";
import star from "../../assets/images/svg/star.svg";
import success from "../../assets/images/svg/success.svg";
import starOutline from "../../assets/images/svg/starOutline.svg";
import dowmloadicon from "../../assets/images/download-white.png";
import extratipicon from "../../assets/images/extra-icon.png";
import deliveredicon from "../../assets/images/delivered-icon.png";
import back from "../../assets/images/svg/back.svg";
import PositionModal from "../../components/modals/OrderPositionModal";
import { styled } from "@mui/material/styles";
import MapComponent from "../../components/maps/MapComponent";
import dayjs from "dayjs";
import { toLocalTime } from "../../helper/functions";
import useOrderDetail from "../../hooks/order/useOrderDetail";
import OrderInvoiceModal from "../../components/modals/OrderInvoice";
import SearchComponent from "../../components/Search";
import PodModal from "../../components/modals/PodModal";
import ExtraTipModal from "../../components/modals/ExtraTipsModal";
import OrderCountdownTimer from "../../components/cards/OrderCountdownTimer";

const displyStatus = {
  Reject: "Order Rejected",
  Review: "Order kept on Review",
};

export const orderStatusIcon = {
  "Order Booked": add,
  "Driver Matched": driver,
  "Order Completed": success,
  Reject: reject,
  Review: reviewRed,
  "Order Reinstated": reload,
  Cancelled: reject,
  "Order Delivered": deliveredicon,
  "Extra Tip OB": extratipicon,
};

// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------
const CustomStepConnector = () => (
  <StepConnector
    sx={{
      "& .MuiStepConnector-line": {
        display: "block",
        borderColor: "#683C8C",
        borderLeftStyle: "dashed",
        borderLeftWidth: "1px",
        minHeight: "24px",
      },
    }}
  />
);
// CUSTOM STEPPER FOR ORDER DETAIL ------------------------------

// CUSTOM TOOLTIP ====================================
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: 140, // Custom maxWidth for Tooltip
    minHeight: 56, // Custom maxWidth for Tooltip
    background: "#795898", // Additional styles if needed
    color: "#fff", // Additional styles if needed
    fontSize: "8px", // Additional styles if needed
    padding: "8px", // Additional styles if needed
    position: "absolute",
    top: "-38px",
    left: "-90px",
    borderRadius: "0",
  },
});

export default function OrderDetail() {
  const {
    order,
    orderItems,
    navigate,
    setSearchInput,
    setFiltrationData,
    styles,
    selectedRow,
    handleCloseModal,
    handlePositionSubmit,
    positionBtn,
    positionPlaceholder,
    client,
    mergedSteps,
    positionModalOpen,
    positionModalTitle,
    searchInput,
    modalState,
    setModalState,
    setOrderItems,
  } = useOrderDetail();
  // ORDER DETAILS COLUMNS----------------------------
  const orderDetailcolumns = [
    {
      id: "puDoId",
      label: "Pickup ID",
      align: "center",
      renderCell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row.puDoId}
          </Typography>
        );
      },
    },
    {
      id: "itemName",
      label: "Item Name",
      align: "center",
      renderCell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row.itemName || "NA"}
          </Typography>
        );
      },
    },
    {
      id: "category",
      label: "Category ",
      align: "center",
      renderCell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row.category?.name || "NA"}
          </Typography>
        );
      },
    },
    {
      id: "expectedBy",
      label: "Expected By",
      align: "center",
      renderCell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row?.date
              ? dayjs(new Date(row?.date)).format("D MMM YYYY, h:mm A")
              : "Not Available 🚫"}
          </Typography>
        );
      },
    },
    {
      id: `${
        orderItems[0]?.type === "Pickup" ? "pickupaddress" : "dropoffaddress"
      }`,
      label: "Address",
      align: "center",
      renderCell: (row) => {
        return row.pickupaddress.length > 36 ? (
          <Tooltip PopperProps={{ placement: "top" }} title={row.pickupaddress}>
            <Typography
              sx={{
                fontSize: "12px",
                color:
                  row.type == "Dropoff"
                    ? "rgba(68, 27, 229, 1)"
                    : "rgba(86, 93, 109, 1)",
              }}
            >
              {row.type === "Pickup"
                ? row.pickupaddress?.slice(0, 36) + "..."
                : row.pickupaddress?.slice(0, 36) + "..."}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row.type === "Pickup" ? row.pickupaddress : row.pickupaddress}
          </Typography>
        );
      },
    },
    {
      id: "amount",
      label: "Amount",
      align: "center",
      renderCell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row.amount}
          </Typography>
        );
      },
    },
    {
      id: "paidBy",
      label: "Paid By",
      align: "center",
      renderCell: (row) => {
        return (
          <Typography
            sx={{
              fontSize: "12px",
              color:
                row.type == "Dropoff"
                  ? "rgba(68, 27, 229, 1)"
                  : "rgba(86, 93, 109, 1)",
            }}
          >
            {row.paidBy || "NA"}
          </Typography>
        );
      },
    },
  ];
  // ORDER DETAILS COLUMNS----------------------------

  // =============================client waiting time
  const calculateWaitingTime = (dateBooked) => {
    const bookedDate = new Date(dateBooked);
    const now = new Date();
    const diffMs = now - bookedDate; // Difference in milliseconds
    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60)); // Convert milliseconds to hours
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60)); // Remaining minutes

    return `${diffHrs} Hr ${diffMins} Min`;
  };

  const waitingTime = calculateWaitingTime(order.dateBooked);

  //FUNCTION TO GO TO BACK PAGE
  const handleBackClick = () => {
    navigate(-1);
  };

  const handleSearchInputChange = (value) => {
    setSearchInput(value);
    setFiltrationData((prevData) => ({
      ...prevData,
      search: value,
    }));
  };
  // orderItems.sort((a) => (a.type === "Pickup" ? -1 : 1));

  return (
    <Grid container sx={{ padding: "0 24px" }} spacing={1}>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <IconButton onClick={handleBackClick} sx={{ marginLeft: "-10px" }}>
            <img src={back} />
          </IconButton>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: 6,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "24px",
                  marginTop: "5px",
                  color: "#673C8E", // Return the value directly
                }}
              >
                Order ID / {order.orderId}
              </Typography>
              <img src={order.is_vip ? star : starOutline} />
            </Box>
            <Box sx={{ marginTop: "12px", position: "relative" }}>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "13px",
                  color: "#673C8E", // Return the value directly
                  position: "absolute",
                  top: "10px",
                  left: "-3px",
                }}
              >
                Booked : {toLocalTime(order.dateBooked, "DD MMM YYYY - h:mm A")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        display="flex"
        justifyContent="end"
        gap={2}
        alignItems="center"
        sx={{ paddingRight: "16px", marginBottom: "20px" }}
      >
        <Box display={"flex"} alignItems={"center"} gap={"10px"}>
          <Button
            variant="outlined"
            size="small"
            sx={{
              padding: "10px 50px",
              width: "175px",
              height: "45px",
              borderRadius: "0px",
              fontWeight: 600,
              textTransform: "capitalize",
              borderColor: styles.background,
              background: styles.background,
              color: styles.color,
              "&:hover": {
                outline: styles.background,
                background: styles.background,
              },
              "&:focus": {
                outline: styles.background,
                background: styles.background,
              },
            }}
          >
            {/* Status */}
            {order.currentStatus.status || order.currentStatus[0].status}
          </Button>
          <Button
            onClick={() =>
              setModalState((modalState) => ({
                ...modalState,
                invoiceOpen: true,
              }))
            }
            variant="outlined"
            size="small"
            sx={{
              padding: "10px 50px",
              textTransform: "capitalize",
              background: "#683C8C !important",
              color: "white",
              borderRadius: "12px",
              fontWeight: 600,
              width: "175px",
              height: "45px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <img src={dowmloadicon} alt="download-icon" /> Invoice
          </Button>
        </Box>
      </Grid>

      <Box
        width={"100%"}
        pl="8px"
        pr={"16px"}
        display="flex"
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box sx={{ marginTop: "0px", marginLeft: "35px" }}>
          <Typography
            variant="h5"
            sx={{
              fontSize: "13px",
              color: "#673C8E", // Return the value directly
              textWrap: "nowrap",
            }}
          >
            Booked Location : {order.bLocation}
          </Typography>
        </Box>
        <Box sx={{ marginLeft: "auto", display: "flex", gap: "10px" }}>
          <ExtraTipModal orderId={order.orderId} />
          <Button
            variant="contained"
            size="small"
            sx={{
              padding: "10px",
              width: "175px",
              height: "45px",
              borderRadius: "12px",
              fontWeight: 600,
              textTransform: "capitalize",
              backgroundColor: "#673C8E",
              color: "#fff",
              borderColor: "#683C8C",
              "&:hover": {
                backgroundColor: "#673C8E",
                color: "#fff",
                borderColor: "#683C8C",
              },
            }}
          >
            Total Amount - ${order.amount}
          </Button>
        </Box>
      </Box>
      {/* Order Countdown Timer */}
      {order.currentStatus.status === "Processing" && (
        <Grid item xs={12}>
          <OrderCountdownTimer order={order} orderItems={orderItems} />
        </Grid>
      )}
      <Grid item xs={12} md={3} mt={2}>
        {/* =========================== CLIENT DETAILS BOX ================================ */}
        <Box
          sx={{
            border: "1px solid #683C8C",
            position: "relative",
            marginTop: "14px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 0",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Avatar
              alt={client.name}
              src={client.profile}
              sx={{
                width: 58,
                height: 58,
                color: "#fff",
                background: "rgba(104, 60, 140, 0.35)",
              }}
            />
            <Typography sx={{ fontWeight: 600 }}>
              {client?.customerID}
            </Typography>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#683C8C",
                color: "#FFFFFF",
                borderColor: "#683C8C",
                padding: "2px 60px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#683C8C",
                  color: "#FFFFFF",
                  borderColor: "#683C8C",
                },
              }}
            >
              {client?.name}
            </Button>
          </Box>
        </Box>
        {/* =========================== CLIENT DETAILS BOX ================================ */}

        {/* =================================== ORDER HISTORY BOX ==================================== */}
        <Box
          sx={{
            marginTop: "15px",
            border: "1px solid #683C8C",
            position: "relative",
            padding: "20px",
            marginBottom: "20px",
            height: "524px",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <Box
            display="flex"
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography
              sx={{
                color: "rgba(104, 60, 140, 1)",
                fontWeight: 600,
                fontSize: "20px",
              }}
            >
              History
            </Typography>
            {order.currentStatus?.status === "Delivered" && (
              <Button
                onClick={() =>
                  setModalState((modalState) => ({
                    ...modalState,
                    podOpen: true,
                  }))
                }
                sx={{
                  backgroundColor: "black !important",
                  borderRadius: "12px",
                  width: "83px",
                  height: "25px",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                variant="contained"
                size="small"
              >
                POD
              </Button>
            )}
          </Box>

          {/* =================================== ORDER HISTORY BOX ==================================== */}

          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            sx={{}}
          >
            {mergedSteps.length > 0 ? (
              <Stepper
                activeStep={3}
                orientation="vertical"
                connector={<CustomStepConnector />}
              >
                {mergedSteps.map((step, index) =>
                  step.reason ? (
                    <CustomTooltip
                      key={index}
                      title={step.reason || "No reason provided"}
                      sx={{
                        "& .MuiTooltip-tooltip": {
                          background: "#795898",
                          color: "#fff",
                          fontSize: "8px",
                          padding: "8px",
                        },
                        "& .MuiStep-root:hover .MuiTooltip-tooltip": {
                          background: "red",
                        },
                      }}
                    >
                      <Step>
                        <StepLabel icon={step.icon}>
                          <Typography
                            sx={{
                              color: "rgba(104, 60, 140, 1)",
                              fontSize: "13px",
                              fontWeight: 600,
                            }}
                          >
                            {displyStatus[step.label] || step.label}
                          </Typography>
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: "10px",
                            }}
                          >
                            {step.description}
                          </Typography>
                        </StepLabel>
                      </Step>
                    </CustomTooltip>
                  ) : (
                    <Step>
                      <StepLabel icon={step.icon}>
                        <Typography
                          sx={{
                            color: "rgba(104, 60, 140, 1)",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          {displyStatus[step.label] || step.label}
                        </Typography>

                        <Box>
                          <Typography
                            sx={{
                              color: "black",
                              fontSize: "10px",
                            }}
                          >
                            {step.description}
                          </Typography>
                        </Box>
                      </StepLabel>
                    </Step>
                  ),
                )}
              </Stepper>
            ) : (
              "No History Recorded!"
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={9}>
        <Box
          paddingX={"18px"}
          sx={{
            marginTop: "-8px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          {/* <Box
            sx={{
              paddingLeft: "14px",
              display: "flex",
              gap: 3,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: "13px",
                color: "#673C8E", // Return the value directly
              }}
            >
              Total Pickups {order.tpu}/{order.ppu} Pending
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: "13px",
                color: "#673C8E", // Return the value directly
              }}
            >
              Client Waiting - {waitingTime}
            </Typography>
          </Box> */}
        </Box>
        {/* ==================================== ORDER ITEMS DATA IN TABLE ====================================== */}
        <Box sx={{ position: "relative" }}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            mt={"16px"}
            gap="27px"
            px={"14px"}
          >
            <SearchComponent
              width={"453px"}
              setSortedData={setOrderItems}
              onSearchData={handleSearchInputChange}
              padding="2px"
              borderRadius="8px"
              totalData={orderItems}
              placeholder="Search In This Section"
              type="orderDetails"
              value={searchInput}
            />
            <Box
              sx={{
                display: "flex",
                gap: "53px",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: "13px",
                  color: "#673C8E", // Return the value directly
                }}
              >
                Total Pickups {order.tpu}/{order.ppu} Pending
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "13px",
                  color: "#673C8E", // Return the value directly
                }}
              >
                Client Waiting - {waitingTime}
              </Typography>
            </Box>
          </Box>
          <DashboardTable
            rows={orderItems}
            columns={orderDetailcolumns}
            emptyMessage="No current pickup/dropoff !"
            onRowClick={(row) => {
              row.type == "Dropoff"
                ? navigate(`/order-detail/dropoff-details`, {
                    state: {
                      pickup: row,
                      selectedOrder: order,
                    },
                  })
                : navigate(`/order-detail/pickup-details`, {
                    state: {
                      pickup: row,
                      selectedOrder: order,
                    },
                  });
            }}
          />
          {/* <DynamicTable
            columns={orderDetailcolumns}
            rows={orderItems}
            searchPlaceholderData={searchInput}
            onSearchData={handleSearchInputChange}
            filtrationData={filtrationData}
            noRecordTitle="No current pickup/dropoff !"
            type="orderDetails"
            otherRow={order}
            paginationProps={{ limit, page, setLimit, setPage, total }}
          /> */}
        </Box>
        {/* ==================================== ORDER ITEMS DATA IN TABLE ====================================== */}

        {/* ==================================  ORDER TRACKING BOX======================================== */}
        <Paper
          elevation={2}
          sx={{
            marginTop: "150px",
            margin: "0 20px",
            padding: "24px",
            marginTop: "-40px",
            marginBottom: "20px",
            height: "450px",
            position: "relative",
            backgroundColor: "white",
          }}
        >
          <Typography
            sx={{
              color: "rgba(104, 60, 140, 1)",
              fontSize: "20px",
              fontWeight: 600,
              mb: 2,
            }}
          >
            Tracking
          </Typography>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 2,
              height: "240px",
            }}
          >
            <Box
              sx={{
                width: "70%",
                height: "inherit",
              }}
            >
              {orderItems.length > 0 && (
                <MapComponent
                  orderItems={orderItems}
                  pickups={orderItems.slice(0, orderItems.length - 1)}
                  dropoff={orderItems.slice(orderItems.length - 1)}
                />
              )}
            </Box>
            <Box
              sx={{
                width: "30%",
                background: "rgba(104, 60, 140, 0.35)",
                padding: "16px",
                height: "inherit",
              }}
            >
              <Typography
                sx={{ color: "#673C8E", fontSize: "17px", fontWeight: 600 }}
              >
                Delivery/Dropoff Notes
              </Typography>
              <Typography
                sx={{
                  color: orderItems[orderItems.length - 1]?.drivernote
                    ? "#000000"
                    : "#e05656",
                  fontSize: "12px",
                  fontWeight: 400,
                  marginTop: "15px",
                }}
              >
                {orderItems[orderItems.length - 1]?.drivernote ||
                  "No Notes Added!"}
              </Typography>
            </Box>
          </Box>

          {/* ----------------- DELIVERY BY ------------------- */}
          <Box sx={{ position: "absolute", bottom: "20px" }}>
            <Typography
              sx={{
                color: "rgba(104, 60, 140, 1)",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              Delivery By
            </Typography>
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                gap: 3,
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Avatar alt="R" />
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {order?.driver?.name || "NA"}
                  </Typography>
                  {order?.driver?.driverID && (
                    <Typography
                      sx={{ fontSize: "13px", color: "rgba(99, 99, 99, 1)" }}
                    >
                      ID - {order?.driver?.driverID}
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "start", gap: 2 }}>
                <Card
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    gap: 2,
                    padding: "13px",
                    width: "205px",
                  }}
                >
                  <IconButton
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(104, 60, 140, 1)",
                      background: "rgba(104, 60, 140, 0.35)",
                      color: "rgba(104, 60, 140, 1)",
                    }}
                  >
                    <PhoneOutlined />
                  </IconButton>
                  <Box>
                    <Typography sx={{ fontSize: "10px" }}>Telephone</Typography>
                    <Typography sx={{ fontSize: "10px", mt: 1 }}>
                      {order?.driver?.phone || "Not Available 🚫"}
                    </Typography>
                  </Box>
                </Card>
                <Card
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    gap: 2,
                    padding: "13px",
                    width: "205px",
                  }}
                >
                  <IconButton
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(104, 60, 140, 1)",
                      background: "rgba(104, 60, 140, 0.35)",
                      color: "rgba(104, 60, 140, 1)",
                    }}
                  >
                    <img src={truck} />
                  </IconButton>
                  <Box>
                    <Typography sx={{ fontSize: "10px" }}>
                      Expected Delivery
                    </Typography>
                    <Typography sx={{ fontSize: "10px", mt: 1 }}>
                      {orderItems[orderItems.length - 1]?.time
                        ? toLocalTime(
                            new Date(orderItems[orderItems.length - 1]?.time),
                            "DD MMM YYYY - h:mm A",
                          )
                        : "Not Available 🚫"}
                    </Typography>
                  </Box>
                </Card>
                <Card
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    gap: 2,
                    padding: "13px",
                    width: "205px",
                  }}
                >
                  <IconButton
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(104, 60, 140, 1)",
                      background: "rgba(104, 60, 140, 0.35)",
                      color: "rgba(104, 60, 140, 1)",
                    }}
                  >
                    <img src={info} />
                  </IconButton>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "10px",
                        color: orderItems[orderItems.length - 1]?.inHandDelivery
                          ? "#BE0B0E"
                          : "#074F24",
                      }}
                    >
                      {orderItems[orderItems.length - 1]?.inHandDelivery
                        ? "In Hand Delivery"
                        : "Not In Hand Delivery"}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "10px",
                        mt: 1,

                        color: orderItems[orderItems.length - 1]
                          ?.aptDoorDelivery
                          ? "#BE0B0E"
                          : "#074F24",
                      }}
                    >
                      {orderItems[orderItems.length - 1]?.aptDoorDelivery
                        ? "Apt Door Delivery"
                        : "Not Apt Door Delivery"}
                    </Typography>
                  </Box>
                </Card>
              </Box>
            </Box>
          </Box>
        </Paper>
        {/* ==================================  ORDER TRACKING BOX======================================== */}
      </Grid>
      {positionModalOpen && selectedRow && (
        <PositionModal
          ifOrder={false}
          open={positionModalOpen}
          title={positionModalTitle}
          onSubmit={handlePositionSubmit}
          onClose={handleCloseModal}
          btnText={positionBtn}
          placeholder={positionPlaceholder}
        />
      )}
      {modalState.invoiceOpen && (
        <OrderInvoiceModal
          order={order}
          open={modalState.invoiceOpen}
          onClose={() =>
            setModalState((modalState) => ({
              ...modalState,
              invoiceOpen: false,
            }))
          }
        />
      )}
      {modalState.podOpen && (
        <PodModal
          onClose={() =>
            setModalState((modalState) => ({ ...modalState, podOpen: false }))
          }
          open={modalState.podOpen}
          order={order}
          dropoff={orderItems.find((obj) => obj.type === "Dropoff")}
        />
      )}
    </Grid>
  );
}
